import React, { useState, useEffect, useMemo } from "react";
import Anime from "react-anime";

import "../css/TextInput.css";

function mapLetters(string) {
  return [...string].map((letter, index) => (
    <span className="animatedLetter" key={letter + index}>
      <Anime
        easing="easeInExpo"
        duration={150}
        opacity={[0, 1]}
        translateY={[-50, 0]}
      >
        {letter}
      </Anime>
    </span>
  ));
}

export default function TextInput({
  onType,
  canType,
  correctWord,
  hasTyped,
  words,
  onFirstType,
  onFinishWord,
  setReset,
}) {
  const [letterIndex, setLetterIndex] = useState(0);
  const [wrongIndex, setWrongIndex] = useState(0);
  const [isWrong, setIsWrong] = useState(false);
  const [word, setWord] = useState([]);

  useEffect(() => {
    const callback = () => {
      setIsWrong(false);
      setLetterIndex(0);
      setWrongIndex(0);
      setWord([]);
    };
    setReset(() => callback);
  }, [setReset]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Backspace" && (!hasTyped || canType)) {
        word.pop();
        setWord([...word]);
        if (!isWrong) {
          setLetterIndex(Math.max(0, word.length));
        }
        if (word.length <= wrongIndex) {
          setWrongIndex(0);
          setIsWrong(false);
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [canType, hasTyped, isWrong, wrongIndex, letterIndex, word]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key.length === 1) {
        if (hasTyped && !canType) {
          return;
        }
        if (event.key === " ") {
          if (word.length === correctWord.length && !isWrong) {
            onFinishWord(word);
            setWord([]);
            setLetterIndex(0);
            return;
          }
          return;
        }
        if (!canType) {
          onFirstType();
        }
        let newWord = [...word, event.key];
        let isLetterWrong = false;
        if (event.key !== correctWord.charAt(letterIndex) && !isWrong) {
          isLetterWrong = true;
          setWrongIndex(letterIndex);
          setIsWrong(true);
        }
        if (!isLetterWrong && !isWrong) {
          setLetterIndex(newWord.length);
        }
        onType(!isLetterWrong && !isWrong);
        setWord(newWord);
      }
    };
    document.addEventListener("keypress", handleKeyPress);
    return () => document.removeEventListener("keypress", handleKeyPress);
  }, [
    onType,
    hasTyped,
    canType,
    onFirstType,
    onFinishWord,
    isWrong,
    correctWord,
    wrongIndex,
    letterIndex,
    word,
  ]);

  const wordString = useMemo(() => word.reduce((acc, char) => acc + char, ""), [
    word,
  ]);

  const leftText = isWrong ? (
    <>
      <span className="correct">
        {mapLetters(wordString.substring(0, wrongIndex))}
      </span>
      <span className="wrong">
        {mapLetters(wordString.substring(wrongIndex, wordString.length))}
      </span>
    </>
  ) : (
    <span className="correct">{mapLetters(wordString)}</span>
  );

  return (
    <div className="textinput">
      <div className="text">
        <div className="leftText">{leftText}</div>
        <div className="bar" />
        <div className="rightText">
          {correctWord?.substring(letterIndex, correctWord.length)}
          {" " + words.join(" ")}
        </div>
      </div>
    </div>
  );
}
